import { localize } from "utils/localizer";

// shared translations
const i18n = {
    sportForms: {
        en: {
            archery: "Archery",
            badminton: "Badminton",
            baseball: "Baseball",
            basketball: "Basketball",
            boule: "Boule",
            bowling: "Bowling",
            dancing: "Dancing",
            darts: "Darts",
            "dog-sport": "Dog sports",
            calisthenics: "Calisthenics",
            bmx: "BMX",
            fitness: "Fitness",
            golf: "Golf",
            handball: "Handball",
            hockey: "Hockey",
            "horseback-riding": "Horseback Riding",
            "ice-hockey": "Ice hockey",
            "kids-sports": "Kids sports",
            multisport: "Multisport",
            mindfulness: "Mindfulness",
            padel: "Padel",
            parkour: "Parkour",
            running: "Running",
            sailing: "Sailing",
            skateboard: "Skateboard",
            soccer: "Soccer",
            "sport-im-park": "Sport im Park",
            "table-tennis": "Table Tennis",
            swimming: "Swimming",
            tennis: "Tennis",
            "touch-tennis": "Touchtennis",
            volleyball: "Volleyball",
            yoga: "Yoga",
        },
        de: {
            archery: "Bogenschießen",
            badminton: "Badminton",
            baseball: "Baseball",
            basketball: "Basketball",
            boule: "Boule",
            bowling: "Bowling",
            dancing: "Tanzen",
            darts: "Dart",
            "dog-sport": "Hundesport",
            calisthenics: "Calisthenics",
            bmx: "BMX",
            fitness: "Fitness",
            golf: "Golf",
            handball: "Handball",
            hockey: "Hockey",
            "horseback-riding": "Reitsport",
            "ice-hockey": "Eishockey",
            "kids-sports": "Kindersport",
            multisport: "Multisport",
            mindfulness: "Achtsamkeit",
            padel: "Padel",
            parkour: "Parkour",
            running: "Laufen",
            sailing: "Segeln",
            skateboard: "Skateboard",
            soccer: "Fußball",
            "sport-im-park": "Sport im Park",
            "table-tennis": "Tischtennis",
            swimming: "Schwimmen",
            tennis: "Tennis",
            "touch-tennis": "Touchtennis",
            volleyball: "Volleyball",
            yoga: "Yoga",
        },
    },
    surfaceTypes: {
        en: {
            "artificial-grass": "Artificial grass",
            asphalt: "Asphalt",
            carpet: "Carpet",
            "carpet-fleece": "Carpet fleece",
            "carpet-with-granulate": "Carpet with granulate",
            clay: "Clay",
            grass: "Grass",
            hard: "Hardcourt",
            "plastic-floor": "Plastic",
            sand: "Sand",
            "table-tennis-indoor": "Indoor plate (wood fiber)",
            "table-tennis-stone": "Outdoor plate (stone)",
            tartan: "Tartan",
            woodchip: "Woodchip",
        },
        de: {
            "artificial-grass": "Kunstrasen",
            asphalt: "Asphalt",
            carpet: "Teppich",
            "carpet-fleece": "Teppichvlies",
            "carpet-with-granulate": "Teppich mit Granulat",
            clay: "Asche",
            grass: "Grass",
            hard: "Hardplatz",
            "plastic-floor": "Kunststoff",
            sand: "Sand",
            "table-tennis-indoor": "Indoor-Platte (Holzfaser)",
            "table-tennis-stone": "Outdoor-Platte (Stein)",
            tartan: "Tartan",
            woodchip: "Hackschnitzel",
        },
    },
};

export default localize(i18n);
